import React from 'react';
import DefaultPopup from 'components/Utils/DefaultPopup';
import Icon from 'components/Utils/NewIcon';
import ProgressMessage from 'components/Utils/ProgressMessage';
const NewCreditCard = React.lazy(() => import('components/Payments/NewCreditCard'));

const PatientAddCardModal = (props) => (
  <DefaultPopup
    title="Add new Credit Card"
    className="add-card-popup"
    openHandler={[props.showModal, (value) => props.openModal(value)]}
  >
    <div className="column credit-card-content">
      <Icon src="credit-card" width="80px" className="my-3 mx-auto blue" />
      <React.Suspense fallback={<ProgressMessage />}>
        <NewCreditCard
          onSuccess={() => {
            props.onAddSuccess();
            props.openModal(false);
          }}
          patient={props.patient}
          white={true}
        />
      </React.Suspense>
    </div>
  </DefaultPopup>
);

export default PatientAddCardModal;
